import React from 'react';
import './App.css';
import SampleSizeCalculator from './components/SampleSizeCalculator';
import StatisticalMethodsExplanation from './components/StatisticalMethodsExplanation';
import ThemeSwitcher from './components/ThemeSwitcher';
import { ThemeProvider } from './context/ThemeContext';

function App() {
  return (
    <ThemeProvider>
      <div className="min-h-screen bg-gray-100 dark:bg-gray-900 text-gray-900 dark:text-gray-100">
        <div className="container mx-auto px-4 py-8">
          <div className="flex justify-end mb-4">
            <ThemeSwitcher />
          </div>
          <header className="mb-8">
            <h1 className="text-3xl font-bold text-center">A/B Test Sample Size Calculator</h1>
            <p className="text-center mt-2 text-gray-600 dark:text-gray-400">
              Calculate the required sample size for your A/B tests to achieve statistical significance
            </p>
          </header>
          <main>
            {/* Main Calculator */}
            <SampleSizeCalculator />
            
            {/* Separator */}
            <div className="my-10 flex items-center">
              <div className="flex-grow h-px bg-gray-300 dark:bg-gray-700/50"></div>
              <span className="px-4 text-sm text-gray-500 dark:text-gray-400">Additional Resources</span>
              <div className="flex-grow h-px bg-gray-300 dark:bg-gray-700/50"></div>
            </div>
            
            {/* Statistical Explanations */}
            <StatisticalMethodsExplanation />
          </main>
          <footer className="mt-12 text-center text-sm text-gray-500 dark:text-gray-400">
            <p> {new Date().getFullYear()} | A/B Test Sample Size Calculator by Lukas Rapp</p>
          </footer>
        </div>
      </div>
    </ThemeProvider>
  );
}

export default App;
